// extracted by mini-css-extract-plugin
module.exports = {"compassContainer":"Compass_compassContainer__1zcXr","compassDirection":"Compass_compassDirection__CHkEs","arrow":"Compass_arrow__3fF5t","compassHome":"Compass_compassHome__2yWZX"};